import { render } from "./EditImageForm.vue?vue&type=template&id=f57618cc&scoped=true&ts=true"
import script from "./EditImageForm.vue?vue&type=script&lang=ts"
export * from "./EditImageForm.vue?vue&type=script&lang=ts"

import "./EditImageForm.vue?vue&type=style&index=0&id=f57618cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f57618cc"]])

export default __exports__